var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input } from '@angular/core';
var ApprenticeshipDetailsComponent = /** @class */ (function () {
    function ApprenticeshipDetailsComponent() {
        this.isReadonly = true;
        this.standard = Input('standard');
        this.viewModel = {
            epaText: 'End Point Assessment',
            formalQualText: 'Formal Qualification',
            gatewayEpaText: 'Gateway EPA',
            onProgrammeLearningText: 'On Programme Learning'
        };
    }
    ApprenticeshipDetailsComponent.prototype.doesStandardHaveAdditionalInfo = function () {
        return this.standard.isGatewayEpaRequired ||
            this.standard.isEpaRequired ||
            this.standard.isFormalQualRequired ||
            this.standard.isProgramLearningRequired;
    };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ApprenticeshipDetailsComponent.prototype, "standard", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], ApprenticeshipDetailsComponent.prototype, "isReadonly", void 0);
    ApprenticeshipDetailsComponent = __decorate([
        Component({
            selector: 'apprenticeship-details',
            template: require('./apprenticeship-details.component.html'),
            styles: [require('./apprenticeship-details.component.scss')]
        }),
        __metadata("design:paramtypes", [])
    ], ApprenticeshipDetailsComponent);
    return ApprenticeshipDetailsComponent;
}());
export { ApprenticeshipDetailsComponent };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBwcmVudGljZXNoaXAtZGV0YWlscy5jb21wb25lbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJhcHByZW50aWNlc2hpcC1kZXRhaWxzLmNvbXBvbmVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSxPQUFPLEVBQUUsU0FBUyxFQUFFLEtBQUssRUFBRSxNQUFNLGVBQWUsQ0FBQztBQVVqRDtJQU1JO1FBSmdCLGVBQVUsR0FBWSxJQUFJLENBQUM7UUFLdkMsSUFBSSxDQUFDLFFBQVEsR0FBRyxLQUFLLENBQUMsVUFBVSxDQUFDLENBQUM7UUFDbEMsSUFBSSxDQUFDLFNBQVMsR0FBRztZQUNiLE9BQU8sRUFBRSxzQkFBc0I7WUFDL0IsY0FBYyxFQUFFLHNCQUFzQjtZQUN0QyxjQUFjLEVBQUUsYUFBYTtZQUM3Qix1QkFBdUIsRUFBRSx1QkFBdUI7U0FDbkQsQ0FBQztJQUNOLENBQUM7SUFFTSx1RUFBOEIsR0FBckM7UUFDSSxPQUFPLElBQUksQ0FBQyxRQUFRLENBQUMsb0JBQW9CO1lBQ3JDLElBQUksQ0FBQyxRQUFRLENBQUMsYUFBYTtZQUMzQixJQUFJLENBQUMsUUFBUSxDQUFDLG9CQUFvQjtZQUNsQyxJQUFJLENBQUMsUUFBUSxDQUFDLHlCQUF5QixDQUFDO0lBQ2hELENBQUM7SUFwQlE7UUFBUixLQUFLLEVBQUU7O29FQUEwQztJQUN6QztRQUFSLEtBQUssRUFBRTs7c0VBQW1DO0lBRmxDLDhCQUE4QjtRQUwxQyxTQUFTLENBQUM7WUFDUCxRQUFRLEVBQUUsd0JBQXdCO1lBQ2xDLFFBQVEsRUFBRSxPQUFPLENBQUMseUNBQXlDLENBQUM7WUFDNUQsTUFBTSxFQUFFLENBQUMsT0FBTyxDQUFDLHlDQUF5QyxDQUFDLENBQUM7U0FDL0QsQ0FBQzs7T0FDVyw4QkFBOEIsQ0FzQjFDO0lBQUQscUNBQUM7Q0FBQSxBQXRCRCxJQXNCQztTQXRCWSw4QkFBOEIifQ==